<template>
  <button
    type="button"
    class="btn-back"
    @click="routeBack()"
  >
    <img
      src="/icons/outline/chevron-left.svg"
      alt="뒤로가기 아이콘"
    />
  </button>
</template>

<script setup lang="ts">
import { useBack } from '@/uComposables/_common/navigation'
const { routeBack } = useBack()
</script>

<style scoped lang="scss">
.btn-back {
  padding: 0;
  width: 24px;
  height: 24px;
  text-align: center;
  border: none;
  background-color: $base-white;
}
</style>
